import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import Resources from '../../core/constants/resources';

import { SessionStorageService } from '../services/session.service';

@Injectable({
  providedIn: 'root'
})
export class LoginGuardService implements CanActivate {

  constructor(
    private _router: Router,
    private sessionService: SessionStorageService
  ) { }

  canActivate(): boolean {
    if (this.sessionService.getItemFromMemory(Resources.SessionStorageKeys.IsLoggedInUser) || this.sessionService.getItemFromMemory(Resources.SessionStorageKeys.CustomerId)) {
      return true;
    } else {
      this._router.navigate([''])
      return true;
    }
  }
}
